import common from '@/i18n/en/common'
import components_optimizeSite_settingModel from '@/i18n/en/components_optimizeSite_settingModel'
import optimizePage_invoiceCollector_invoiceEditor from '@/i18n/en/optimizePage_invoiceCollector_invoiceEditor'
import components_utils_dialogForm from '@/i18n/en/components_utils_dialogForm'
import layout_appSidebar from '@/i18n/en/layout_appSidebar.json'
import route from '@/i18n/en/route.json'
import error_forbidden from '@/i18n/en/error_forbidden.json'
import error_notFound from '@/i18n/en/error_notFound.json'
import exportBatch_batchList from '@/i18n/en/exportBatch_batchList.json'
import optimizeCategory_waterMarkerEdit from '@/i18n/en/optimizeCategory_waterMarkerEdit.json'
import optimizeCategory_waterMarkerList from '@/i18n/en/optimizeCategory_waterMarkerList.json'
import optimizeCheckout_login_detectLogin from '@/i18n/en/optimizeCheckout_login_detectLogin.json'
import partnerFeature_readmeMap from '@/i18n/en/partnerFeature_readmeMap.json'
import setting_container_bindLineGroup from '@/i18n/en/setting_container_bindLineGroup.json'
import setting_container_containerEdit from '@/i18n/en/setting_container_containerEdit.json'
import setting_staff_staffList from '@/i18n/en/setting_staff_staffList.json'
import setting_staff_staffEdit from '@/i18n/en/setting_staff_staffEdit.json'
import user_userAuth from '@/i18n/en/user_userAuth.json'
import user_userForgetPwd from '@/i18n/en/user_userForgetPwd.json'

export default {
  common,
  components_optimizeSite_settingModel,
  optimizePage_invoiceCollector_invoiceEditor,
  components_utils_dialogForm,
  layout_appSidebar,
  route,
  error_forbidden,
  error_notFound,
  exportBatch_batchList,
  optimizeCategory_waterMarkerEdit,
  optimizeCategory_waterMarkerList,
  optimizeCheckout_login_detectLogin,
  partnerFeature_readmeMap,
  setting_container_bindLineGroup,
  setting_container_containerEdit,
  setting_staff_staffList,
  setting_staff_staffEdit,
  user_userAuth,
  user_userForgetPwd,
}
